window.$ = window.jQuery;